import { handleActions } from 'redux-actions';

import * as actions from './actions';

const initialState = {
  data: [],
  activeClassmatesFilters: null,
};

const options = { prefix: 'Volunteers' };

const reducer = handleActions(
  {
    [actions.set]: {
      next(state, { payload }) {
        return { ...state, ...payload, _lastUpdated: Date.now() };
      },
      throw(state) {
        return state;
      },
    },
  },
  initialState,
  options
);

export default reducer;
